import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_376: DocMigration = {
  maxSchemaVersion: "0.0.376",
  description: "Roof height offset refactoring",
  apply(json: any) {
    const { roofs } = json;

    // roof instances
    for (const roofId in roofs) {
      const roof = roofs[roofId];
      const { roofSettings = {}, roofSideOverrides = {} } = roof;

      // move the heel height offsets to the roof side overrides
      if (
        roofSettings.eaveLeftFasciaHeightOffsetOverride !== undefined &&
        roofSettings.eaveLeftFasciaHeightOffsetOverride !== null
      ) {
        roof.roofSideOverrides["LEFT"] = {
          ...roofSideOverrides["LEFT"],
          heelHeightOffset: roofSettings.eaveLeftFasciaHeightOffsetOverride,
        };

        delete roofSettings.eaveLeftFasciaHeightOffsetOverride;
      }

      if (
        roofSettings.eaveRightFasciaHeightOffsetOverride !== undefined &&
        roofSettings.eaveRightFasciaHeightOffsetOverride !== null
      ) {
        roof.roofSideOverrides["RIGHT"] = {
          ...roofSideOverrides["RIGHT"],
          heelHeightOffset: roofSettings.eaveRightFasciaHeightOffsetOverride,
        };

        delete roofSettings.eaveRightFasciaHeightOffsetOverride;
      }

      // mark existing roofs as having legacy heel height offsets
      roofs[roofId] = {
        ...roof,
        legacyHeelHeightOffsets: true,
      };
    }

    return json;
  },
};

export default migration_0_0_376;
